var map = {
	"./pages/about/about.module": [
		"./src/app/pages/about/about.module.ts",
		"pages-about-about-module"
	],
	"./pages/account/account.module": [
		"./src/app/pages/account/account.module.ts",
		"pages-account-account-module"
	],
	"./pages/business-virtualtours/business-virtualtours.module": [
		"./src/app/pages/business-virtualtours/business-virtualtours.module.ts",
		"pages-business-virtualtours-business-virtualtours-module"
	],
	"./pages/business/business.module": [
		"./src/app/pages/business/business.module.ts",
		"pages-business-business-module"
	],
	"./pages/campustour/campustour.module": [
		"./src/app/pages/campustour/campustour.module.ts",
		"pages-campustour-campustour-module"
	],
	"./pages/campustours/campustours.module": [
		"./src/app/pages/campustours/campustours.module.ts",
		"pages-campustours-campustours-module"
	],
	"./pages/cities/cities.module": [
		"./src/app/pages/cities/cities.module.ts",
		"pages-cities-cities-module"
	],
	"./pages/city2/city2.module": [
		"./src/app/pages/city2/city2.module.ts",
		"pages-city2-city2-module"
	],
	"./pages/disclaimer/disclaimer.module": [
		"./src/app/pages/disclaimer/disclaimer.module.ts",
		"pages-disclaimer-disclaimer-module"
	],
	"./pages/edit/edit.module": [
		"./src/app/pages/edit/edit.module.ts",
		"pages-edit-edit-module"
	],
	"./pages/foodmap/foodmap.module": [
		"./src/app/pages/foodmap/foodmap.module.ts",
		"pages-foodmap-foodmap-module"
	],
	"./pages/home/home.module": [
		"./src/app/pages/home/home.module.ts",
		"pages-home-home-module"
	],
	"./pages/home2/home2.module": [
		"./src/app/pages/home2/home2.module.ts",
		"pages-home2-home2-module"
	],
	"./pages/media/media.module": [
		"./src/app/pages/media/media.module.ts",
		"pages-media-media-module"
	],
	"./pages/moviemap/moviemap.module": [
		"./src/app/pages/moviemap/moviemap.module.ts",
		"pages-moviemap-moviemap-module"
	],
	"./pages/musicmap/musicmap.module": [
		"./src/app/pages/musicmap/musicmap.module.ts",
		"pages-musicmap-musicmap-module"
	],
	"./pages/nearby2/nearby2.module": [
		"./src/app/pages/nearby2/nearby2.module.ts",
		"pages-nearby2-nearby2-module"
	],
	"./pages/new/new.module": [
		"./src/app/pages/new/new.module.ts",
		"common",
		"pages-new-new-module"
	],
	"./pages/news/news.module": [
		"./src/app/pages/news/news.module.ts",
		"pages-news-news-module"
	],
	"./pages/pin-a-video/pin-a-video.module": [
		"./src/app/pages/pin-a-video/pin-a-video.module.ts",
		"common",
		"pages-pin-a-video-pin-a-video-module"
	],
	"./pages/privacy-policy/privacy-policy.module": [
		"./src/app/pages/privacy-policy/privacy-policy.module.ts",
		"pages-privacy-policy-privacy-policy-module"
	],
	"./pages/stories/stories.module": [
		"./src/app/pages/stories/stories.module.ts",
		"pages-stories-stories-module"
	],
	"./pages/story/story.module": [
		"./src/app/pages/story/story.module.ts",
		"pages-story-story-module"
	],
	"./pages/tag2/tag2.module": [
		"./src/app/pages/tag2/tag2.module.ts",
		"pages-tag2-tag2-module"
	],
	"./pages/terms-of-service/terms-of-service.module": [
		"./src/app/pages/terms-of-service/terms-of-service.module.ts",
		"pages-terms-of-service-terms-of-service-module"
	],
	"./pages/tour/tour.module": [
		"./src/app/pages/tour/tour.module.ts",
		"pages-tour-tour-module"
	],
	"./pages/tours/tours.module": [
		"./src/app/pages/tours/tours.module.ts",
		"pages-tours-tours-module"
	],
	"./pages/user/user.module": [
		"./src/app/pages/user/user.module.ts",
		"pages-user-user-module"
	],
	"./pages/video-modal/video-modal.module": [
		"./src/app/pages/video-modal/video-modal.module.ts"
	],
	"./pages/video/video.module": [
		"./src/app/pages/video/video.module.ts",
		"pages-video-video-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;